const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the  custom-line-chart directive displaying the correlation between different stats 
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('customLineChart', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        chartData: '=',
        loading: '='
      },
      template: require('../../templates/directives/custom-line-chart.html'),
      link: function($scope, $element, attr) {
        var chart = {
          'options' : {
            responsive: true,
            maintainAspectRatio: false,
            scaleShowVerticalLines: false,
            scaleLineColor: '#f7f7f7',
            scaleFontFamily: '"Gotham SSm A","Gotham SSm B",Helvetica,Arial,sans-serif',
            pointDotRadius : 0,
            pointDotStrokeWidth : 0,
            bezierCurve : false,
            showTooltips: false
          },
          seriesChanged: 0,
          activeSeries: [],
          colorConfig: {
            baseColors: [],
            currColors: [],
            dimmedColor: {},
            defaultColors: [0,1,2,3]
          },
          getColor : function(color) {
            return {
              backgroundColor: color[0],
              borderColor: 'transparent',
              pointBackgroundColor: color[1],
              pointBorderColor: 'white',
              pointHoverBackgroundColor: color,
              pointHoverBorderColor: 'white'
            }
          },
          selectStat: function(location) {
          // interactions
            //set which stats are active
            //if initial click set all others to false
            if (!chart.seriesChanged){
              chart.activeSeries = chart.activeSeries.map(function(val, idx){
                return idx === location ? true : false;
              });
              chart.seriesChanged++;
            } else {
              chart.activeSeries[location] = !chart.activeSeries[location];
            }

            //set colors
            chart.colorConfig.currColors = chart.colorConfig.currColors.map(function(val,idx){
              return chart.activeSeries[idx] ? chart.colorConfig.defaultColors[idx] : chart.colorConfig.dimmedColor;
            });

            chart.colours = chart.colorConfig.currColors;
          }
        };

        chart.colorConfig.baseColors = [['rgba(33,190,241,.35)','#21bef1'], ['rgba(54,194,110,.6)','#36c26e'], ['rgba(232,98,87,.5)','#e86257'], ['rgba(253,129,38,.65)','#fd8126'], ['rgba(147,149,151,.5)','#c9cacb']];
        chart.colorConfig.defaultColors = chart.colorConfig.defaultColors.map(function(idx){ return chart.getColor(chart.colorConfig.baseColors[idx]) } );
        chart.colorConfig.dimmedColor = chart.getColor(chart.colorConfig.baseColors[4]);
        chart.colorConfig.currColors = chart.colorConfig.defaultColors;

        //init
        var initialize = function() {
          chart.colours = chart.colorConfig.defaultColors;
          chart.data = [];
          angular.forEach($scope.chartData.series, function(set) {
            chart.data.push(set.data);
            chart.activeSeries.push(true);
          });
          // Provide a zero baseline since the y axis will conform to the LCD
          var zeroY = [];
          for (var i = 0; i < $scope.chartData.xLabels.length; i++) {
            zeroY.push(0);
          }
          chart.data.push(zeroY);
          $scope.chart = chart;
        };

        if ($scope.chartData && $scope.chartData.xLabels && $scope.chartData.xLabels) {
          initialize();
        }

        $scope.$watch('chartData', function(newVal, oldVal) {
          if (!newVal || !newVal.xLabels || !newVal.xLabels.length) {
            return;
          }
          initialize();
        }, true);
      }
    };
  }]);